import { Inject, Injectable } from "@angular/core";
import { OktaAuth } from "@okta/okta-auth-js";
import { OKTA_AUTH } from "@okta/okta-angular";

@Injectable({ providedIn: "root" })
export class LogoutService {
    constructor(@Inject(OKTA_AUTH) private oktaAuthService: OktaAuth) {}

    logout(): void {
        this.oktaAuthService.tokenManager.remove("accessToken");
        this.oktaAuthService.tokenManager.remove("idToken");
        this.oktaAuthService.signOut();
    }
}
